import React from "react";
import { useParams } from "react-router-dom";
import useSWR from "swr";
import { Box, Typography, Grid } from "@mui/material";
import { typo } from "../../../assets/fonts/font";
import colorConfigs from "../../../configs/colorConfigs";
import homePageStyles from "../../../styles/PublicPage/home";
import SingleProductPage from "./SingleProductPage";
import { getCollectionBySlug } from "../../../api/CollectionAPI";
import { getSkus } from "../../../api/SkuAPI";
import { AWS_URL } from "../../../configs/constants";
import { ISkuDetail } from "../../../models/ISkuDetail";

const SingleCollectionPage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();

  const { data: collectionData, error: collectionError } = useSWR(
    `getCollectionBySlug${slug}`,
    async () => getCollectionBySlug(slug || "")
  );

  const { data: productData, error: productError } = useSWR(
    `getSkus`,
    getSkus
  );

  if (collectionError || productError) {
    return <div>Failed to fetch data.</div>;
  }

  if (!collectionData || !productData) {
    return <div>Loading...</div>;
  }
  
  const collection = collectionData.result;
  const collectionId = collection.id; // Get the collection ID from API
  const collectionName = collectionData.result.name;
  const bannerUrl = collectionData.result.banner_url;
  const hasBanner = typeof bannerUrl === "string" && bannerUrl.trim() !== "";
  const filteredProducts = productData.filter((product: { collections: number[] }) =>
    product.collections.includes(Number(collectionId))
  );

  return (
    <Box sx={homePageStyles.Box} key={slug}> {/* Use `key` to force remount */}
      {hasBanner && (
        <Box
          sx={{
            width: "100%",
            backgroundImage: `url(${AWS_URL}/${bannerUrl.trim()})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            textAlign: "center",
            position: "relative",
            height: "300px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 1,
            }}
          />
        </Box>
      )}
      <Typography
        sx={{
          ...typo.sectionHeadline,
          color: colorConfigs.black,
          zIndex: 2,
          display: 'flex',
          justifyContent: 'center',
          paddingTop: 4,
        }}
      >
        {collectionName}
      </Typography>
      <Box
        sx={{
          maxWidth: "1200px",
          width: "90%",
          display: "flex",
          flexDirection: "column",
          background: colorConfigs.secondary,
          justifyContent: "center",
          margin: "auto",
        }}
      >
        <Box sx={{ paddingY: 6 }}>
          <Grid container spacing={2} justifyContent="center">
            {filteredProducts.map((product: ISkuDetail) => (
              <Grid
                item
                key={product.name}
                xs={6}
                sm={6}
                md={4}
                lg={3}
              >
                <Box>
                  <SingleProductPage product={product} />
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default SingleCollectionPage;